var CPC_SEARCH_URL = window.CPC_SEARCH_URL || '/search';

  function addToRFQCartGrid(title, sku, img, url, btn) {
    var qty = 1;
    if (btn && btn.parentNode) {
      var q = btn.parentNode.querySelector('.cpc-qty');
      if (q) qty = Math.max(1, parseInt(q.value, 10) || 1);
    }
    if (window.ComponentHubRFQ) {
      window.ComponentHubRFQ.addToCart(title, sku, img, qty, url);
      if (btn) {
        var label = btn.textContent;
        btn.classList.add('is-added'); btn.textContent = '追加しました ✓';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; }, 1800);
      }
    }
  }

  function submitFilterForm() {
    var form = document.getElementById('CollectionFiltersForm');
    if (!form) return;
    var params = new URLSearchParams(new FormData(form));
    window.location.search = params.toString();
  }

  function setCollectionView(view) {
    var container = document.getElementById('ch-view-container');
    var listView = document.querySelector('.ch-view-list');
    var gridView = document.querySelector('.ch-view-grid');
    var btnList = document.getElementById('btn-view-list');
    var btnGrid = document.getElementById('btn-view-grid');
    if (!container || !listView || !gridView) return;
    var grid = view === 'grid';
    listView.style.display = grid ? 'none' : 'block';
    gridView.style.display = grid ? 'block' : 'none';
    if (btnList) btnList.classList.toggle('active', !grid);
    if (btnGrid) btnGrid.classList.toggle('active', grid);
    container.setAttribute('data-view', grid ? 'grid' : 'list');
    try { localStorage.setItem('ch_collection_view', grid ? 'grid' : 'list'); } catch (e) {}
    if (typeof filterProducts === 'function') filterProducts();
  }

  function filterProducts() {
    var vendors = [], stock = [];
    document.querySelectorAll('.filter-vendor:checked').forEach(function (el) { vendors.push(el.value.toLowerCase()); });
    document.querySelectorAll('.filter-stock:checked').forEach(function (el) { stock.push(el.value); });
    var findEl = document.getElementById('cpc-find');
    var q = findEl ? findEl.value.trim().toLowerCase() : '';

    function match(el, haystack) {
      var vendor = (el.getAttribute('data-vendor') || '').toLowerCase();
      var available = el.getAttribute('data-available') === 'true';
      var mv = vendors.length === 0 || vendors.indexOf(vendor) > -1;
      var ms = stock.length === 0 || (stock.indexOf('instock') > -1 && available) || (stock.indexOf('rfq') > -1 && !available);
      var mq = !q || haystack.indexOf(q) > -1;
      return mv && ms && mq;
    }
    var rows = document.querySelectorAll('.ch-product-row'), visibleRows = 0;
    rows.forEach(function (row) {
      var ok = match(row, row.getAttribute('data-search') || row.textContent.toLowerCase());
      row.style.display = ok ? '' : 'none'; if (ok) visibleRows++;
    });
    var cards = document.querySelectorAll('.ch-product-grid .ch-product-card'), visibleCards = 0;
    cards.forEach(function (card) {
      var ok = match(card, card.textContent.toLowerCase());
      card.style.display = ok ? '' : 'none'; if (ok) visibleCards++;
    });
    var view = 'list';
    try { view = localStorage.getItem('ch_collection_view') || 'list'; } catch (e) {}
    var visible = view === 'grid' ? visibleCards : visibleRows;
    var countSpan = document.getElementById('ch-product-count-number');
    if (countSpan) countSpan.textContent = visible;
    var nomatch = document.getElementById('cpc-nomatch');
    if (nomatch) nomatch.hidden = !(visible === 0 && rows.length > 0);
    var searchUrl = CPC_SEARCH_URL + (q ? '?type=product&q=' + encodeURIComponent(q) : '');
    ['cpc-find-all', 'cpc-nomatch-search'].forEach(function (id) { var a = document.getElementById(id); if (a) a.href = searchUrl; });
  }

  function clearFilters() {
    document.querySelectorAll('.filter-vendor, .filter-stock').forEach(function (el) { el.checked = false; });
    var f = document.getElementById('cpc-find'); if (f) f.value = '';
    filterProducts();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('cpc');
    if (!root) return;

    // View
    var savedView = (document.getElementById('cpc') && document.getElementById('cpc').getAttribute('data-default-view')) || 'list';
    try { savedView = localStorage.getItem('ch_collection_view') || savedView; } catch (e) {}
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('view') === 'grid' || urlParams.get('view') === 'list') savedView = urlParams.get('view');
    setCollectionView(savedView);

    // Client-side filters
    root.querySelectorAll('.filter-vendor, .filter-stock').forEach(function (el) { el.addEventListener('change', filterProducts); });
    var find = document.getElementById('cpc-find');
    if (find) {
      find.addEventListener('input', filterProducts);
      find.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && find.value.trim()) { e.preventDefault(); window.location.href = CPC_SEARCH_URL + '?type=product&q=' + encodeURIComponent(find.value.trim()); }
      });
    }

    // Native (server) filters
    root.querySelectorAll('[data-cpc-native]').forEach(function (el) { el.addEventListener('change', submitFilterForm); });

    // Sort
    var sort = document.getElementById('cpc-sort');
    if (sort) sort.addEventListener('change', function () {
      var p = new URLSearchParams(window.location.search); p.set('sort_by', sort.value); p.delete('page');
      window.location.search = p.toString();
    });

    // Group search + show more
    root.querySelectorAll('[data-cpc-groupsearch]').forEach(function (input) {
      var list = input.parentNode.querySelector('.cpc-opts');
      var more = input.parentNode.querySelector('[data-cpc-showmore]');
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        list.classList.toggle('is-searching', !!q);
        list.querySelectorAll('.cpc-opt').forEach(function (li) { li.classList.toggle('is-hit', !!q && (li.getAttribute('data-label') || '').indexOf(q) > -1); });
        if (more) more.hidden = !!q;
      });
    });
    root.querySelectorAll('[data-cpc-showmore]').forEach(function (btn) {
      var label = btn.textContent;
      btn.addEventListener('click', function () {
        var list = btn.parentNode.querySelector('.cpc-opts');
        var collapsed = list.classList.toggle('is-collapsed');
        btn.textContent = collapsed ? label : '閉じる';
      });
    });

    // Mobile drawer
    var side = document.getElementById('cpc-side');
    var overlay = root.querySelector('.cpc-overlay');
    function openSide(o) {
      if (!side) return;
      side.classList.toggle('is-open', o); if (overlay) overlay.classList.toggle('is-open', o);
      document.body.style.overflow = o ? 'hidden' : '';
    }
    root.querySelectorAll('[data-cpc-open]').forEach(function (b) { b.addEventListener('click', function () { openSide(true); }); });
    root.querySelectorAll('[data-cpc-close]').forEach(function (b) { b.addEventListener('click', function () { openSide(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openSide(false); });

    filterProducts();
  });
